import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ProfileIcon = ({
  color = 'foraBlue',
  width = 18,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <g fill={getSemanticTextColor(color)} fillRule="evenodd">
        <path d="M11.34 10.078c3.452.963 5.988 4.122 5.988 7.88H.951c0-3.758 2.535-6.917 5.988-7.88l2.2 2.202zM9.14.041c2.466 0 4.463 1.998 4.463 4.462 0 2.465-1.997 4.462-4.463 4.462-2.465 0-4.463-1.997-4.463-4.462C4.677 2.04 6.675.041 9.14.041z" />
      </g>
    </svg>
  </DefaultIconWrapper>
);
